
import TaskTypeContent from "../../Component/TaskType/TaskType";

function TaskType() {
  return  <TaskTypeContent />
      
}

export default TaskType;
